export const IconLine = ({
  width = 20,
  height = 21,
  color = 'currentColor',
}) => (
  <svg
    width='1360'
    height='1'
    viewBox='0 0 1360 1'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <line
      x1='-4.37114e-08'
      y1='0.5'
      x2='1360'
      y2='0.499881'
      stroke='url(#paint0_linear_51_1906)'
      strokeOpacity='0.2'
    />
    <defs>
      <linearGradient
        x1='4.37114e-08'
        y1='1.5'
        x2='1360'
        y2='1.49988'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FAFAFC' stopOpacity='0' />
        <stop offset='0.47' stopColor='#FAFAFC' />
        <stop offset='1' stopColor='#FAFAFC' stopOpacity='0' />
      </linearGradient>
    </defs>
  </svg>
);
